import {ChangeDetectionStrategy, Component, HostListener, effect, inject, input, OnInit, signal} from '@angular/core';
import {ButtonModule} from 'primeng/button';
import {debounceTime, distinctUntilChanged, finalize, Observable, take, throwError} from 'rxjs';
import {ProyectoItem} from 'src/app/users/interfaces/proyecto.interface';
import {ProyectoService} from 'src/app/users/proyectos/services/proyecto.service';
import {Location, NgIf} from "@angular/common";
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {SdetTramiteService} from '../../services/sdet-tramite.service';
import {TramiteItem, TramiteTipoRequisitoItem} from '../interfaces/tramites.interface';
import {TramiteService} from '../../services/tramite.service';
import {MessageService} from 'primeng/api';
import {ActivatedRoute, Event, Router} from '@angular/router';
import {TipoAreaEnum} from '../interfaces/formulario.interfaces';
import {TarifarioInterface} from 'src/app/users/interfaces/pagos.interface';
import {LoginServices} from 'src/app/auth/login/services/login.service';
import Swal from "sweetalert2";
import {UserApiResponse} from "../interfaces/formulario-i.interfaces";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {catchError, switchMap, tap} from "rxjs/operators";

@Component({
    selector: 'app-formulario-i',
    standalone: true,
    providers: [MessageService],
    imports: [ButtonModule, NgIf],
    templateUrl: './formulario-i.component.html',
    styleUrl: './formulario-i.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormularioIComponent implements OnInit {
    idTramite = input();
    idProyecto = input();

    private proyectoService = inject(ProyectoService);
    private location = inject(Location);
    private sanitizer = inject(DomSanitizer);
    private sdetTramiteService = inject(SdetTramiteService);
    protected tramiteService = inject(TramiteService);
    private messageService = inject(MessageService);
    private router = inject(Router);
    private route = inject(ActivatedRoute);
    private loginServices = inject(LoginServices);
    private MNR_SYSTEM_URL = 'https://seadot.ambiente.gob.sv/';

    selected = signal<TramiteItem | null>(null);
    tramiteCompleto: boolean = true;
    tarifa: number = 0;
    requisitoTipoTramite: TramiteTipoRequisitoItem[] = [];
    showLoader: boolean = false;

    proyectoAsignado: ProyectoItem[] = [];
    currentProject = signal<ProyectoItem | null>(null);
    mnrSystemUrl = signal<SafeResourceUrl>('');
    apiUrl = 'https://cloud-functions-api-gw-config-926xrm2x.wl.gateway.dev/API-Homologacion-DOT?key=AIzaSyB1ZKHHFTu8ZtMHZaBCXIPcW0vaUZHSGE8';
    responseData!: UserApiResponse;
    isLoading = signal(false);
    constructor(private http: HttpClient) {
    }

    ngOnInit(): void {
        this.loadTramiteData();
        this.preAuthAmbiente().subscribe({
            next: () => {
                this.getProyectById();
            },
            error: (err) => console.error('preAuthAmbiente:', err),
            complete: () => this.buildMNRSystemUrl()
        });
    }

    loadTramiteData(): void {
        if (this.idTramite()) {
            this.sdetTramiteService.obtenerSdetItem(this.tramiteService.idProyecto()!, this.idTramite() as string)
                .pipe(
                    take(1),
                    catchError(error => {
                        this.showErrorMessage('Error al cargar datos del trámite');
                        return throwError(() => error);
                    })
                )
                .subscribe(resp => {
                    if (resp && resp.body) {
                        this.onReceiveTramite(resp.body);
                    }
                });

            this.tramiteService.getRequisitosPorParametros(
                this.idTramite() as string,
                this.idProyecto() as string,
                this.requisitoTipoTramite
            );
        }
    }

    preAuthAmbiente(): Observable<UserApiResponse> {
        return this.callApiHomologacion().pipe(
            tap((result: UserApiResponse) => {
                if (result) {
                    this.responseData = result;
                    console.log('Usuario ID:', result.data.usuario_id);
                }
            }),
            catchError((error) => {
                console.error('API Error:', error);
                return throwError(() => error); // propagate error
            }),
            finalize(() => {
                console.log('API call completed.');
            })
        );
    }

    callApiHomologacion(): Observable<UserApiResponse> {
        const headers = new HttpHeaders({'Content-Type': 'application/json'});
        const body = {
            solicitud: {
                id_dot_user: this.loginServices.session()?.perfil.uniqueId,
                nombre_user: this.loginServices.session()?.perfil.nombreCompleto,
                correo_user: this.loginServices.session()?.perfil.correo,
            }
        };

        return this.http.post<UserApiResponse>(this.apiUrl, body, {headers});
    }

    buildMNRSystemUrl() {
        let finalMarnUrl = `${this.MNR_SYSTEM_URL}?user=${encodeURIComponent(this.loginServices.session()?.perfil.uniqueId ?? '')}&idTramite=${encodeURIComponent(this.currentProject()?.idSolicitud ?? '')}`;
        console.log(`finalMarnUrl: ${finalMarnUrl}`)
        return finalMarnUrl;
    }

    getInfoAreaProyecto(idProyecto: string, tipoProyecto: number, info: string | null) {
        if (info == "tipoareas" && tipoProyecto != null || undefined) {
            this.tramiteService.getObtenerTipoAreas(idProyecto!, []).subscribe(
                resp => {
                    this.tramiteService.tiposAreas.set(resp);
                    this.tramiteService.areaTotalSignal.set(this.getAreaByTipo(TipoAreaEnum.Areaproyecto!));
                }
            );
        }
    }

    getProyectById(): void {
        this.proyectoService.getGeneralesProyecto(this.idProyecto() as string)
            .pipe(
                take(1),
                catchError(error => {
                    this.showErrorMessage('Error al cargar datos del proyecto');
                    return throwError(() => error);
                })
            )
            .subscribe((res) => {
                if (res && res.body) {
                    this.proyectoAsignado = res.body;
                    this.tramiteService.proyectoAsignado.set(res.body);

                    if (res.body.length > 0) {
                        this.currentProject.set((res.body[0] ?? {}) as ProyectoItem);
                        this.tramiteService.selected.set(res.body[0]);

                        this.mnrSystemUrl.set(
                            this.sanitizer.bypassSecurityTrustResourceUrl(this.buildMNRSystemUrl())
                        );

                        this.getInfoAreaProyecto(
                            this.tramiteService.idProyecto()!,
                            this.proyectoAsignado[0].idTipoProyecto!,
                            "tipoareas"
                        );
                    }
                }
            });
    }

    goBack() {
        this.location.back();
    }

    completarTramite() {
        if (this.isLoading()) return;
        this.isLoading.set(true);
        this.obtenerSdetItemTramites();
    }

    obtenerSdetItemTramites() {
        this.showLoader = true;

        this.sdetTramiteService.obtenerSdetItem(this.idProyecto() as string, this.idTramite() as string)
            .pipe(
                take(1),
                catchError(error => {
                    this.showLoader = false;
                    this.showErrorMessage('Error al obtener información del trámite');
                    this.isLoading.set(false);
                    return throwError(() => error);
                })
            )
            .subscribe({
                next: (resp) => {
                    this.showLoader = false;
                    if (resp && resp.body) {
                        this.onReceiveTramite(resp.body);
                        this.procesarTramite();
                    } else {
                        this.showErrorMessage('No se pudo obtener información del trámite');
                    }
                },
                error: () => {
                    this.showLoader = false;
                    this.isLoading.set(false);
                },
                complete: () => {
                    this.showLoader = false;
                    this.isLoading.set(false);
                }
            });
    }

    onReceiveTramite(tramite: TramiteItem): void {
        this.selected.set(tramite);

        if (tramite.idProyecto) {
            this.tramiteService.idProyecto.set(tramite.idProyecto.toString());
        }

        if (tramite.idTramite) {
            this.tramiteService.getRequisitosPorParametros(
                tramite.idTramite.toString(),
                this.idProyecto() as string,
                this.requisitoTipoTramite
            );
        }
    }

    procesarTramite() {
        const selectedTramite = this.selected();

        if (!selectedTramite) {
            this.showErrorMessage('No hay información del trámite seleccionado');
            return;
        }

        this.tramiteCompleto = false;

        if (this.tarifa == null) {
            this.messageService.add({
                severity: 'error',
                summary: '',
                detail: 'Favor calcular la tarifa del trámite'
            });
            this.tramiteCompleto = true;
            return;
        }

        this.validacionPrimerFlujoCompletarTramite();
        this.tramiteCompleto = true;
    }

    validacionPrimerFlujoCompletarTramite() {
        const selectedTramite = this.selected();

        if (!selectedTramite) {
            this.showErrorMessage('No hay información del trámite seleccionado');
            return;
        }

        this.showLoader = true;

        this.tramiteService.completeFormProcess(selectedTramite)
            .pipe(
                debounceTime(1000),
                switchMap(_ => this.tramiteService.completeFormProcess(selectedTramite)),
                catchError(error => {
                    this.showLoader = false;
                    this.showErrorMessage('Error al completar el trámite');
                    return throwError(() => error);
                })
            ).subscribe(
            resp => {
                this.showLoader = false;
                if (resp.status == 200 || resp.status == 201) {
                    const id = selectedTramite.idProyecto ? selectedTramite.idProyecto : 0;
                    this.router.navigate(['/users/pagos/tramites', id]);
                } else {
                    this.showErrorMessage('Error al procesar el trámite');
                }
            }
        );
    }

    validacionBotonCompletarTramite(): boolean {
        return this.tramiteService.idProyecto() == null;
    }

    getAreaByTipo(tipo: TipoAreaEnum) {
        return this.tramiteService.tiposAreas().find(area => area.idTipoArea === tipo)?.area || 0;
    }

    calcularTarifa() {
        if (!this.proyectoAsignado.length || !this.idTramite() || !this.tramiteService.idProyecto()) {
            this.showErrorMessage('Faltan datos necesarios para el cálculo de tarifa');
            return;
        }

        this.tramiteCompleto = true;
        let datos_calcular: TarifarioInterface[] = [
            {
                idEntorno: this.proyectoAsignado[0].idEntorno!,
                idTramite: parseInt(this.idTramite() as string, 10),
                idTipoArea: this.tramiteService.tiposAreas().find(area => area.idTipoArea === TipoAreaEnum.Areaproyecto)?.idTipoArea!,
                area: this.getAreaByTipo(TipoAreaEnum.Areaproyecto!),
                idProyecto: this.tramiteService.idProyecto(),
                creadoPor: this.loginServices.session()?.perfil.usuario,
                idInstitucion: this.loginServices.session()?.perfil.idInstitucion,
                idSolicitud: this.proyectoAsignado[0].idSolicitud!
            }
        ];
        return this.tramiteService.calcularTarifa(datos_calcular);
    }

    onChangeCalcularTarifa() {
        let areaTotal = this.getAreaByTipo(TipoAreaEnum.Areaproyecto!);
        if (areaTotal != null && areaTotal != 0) {
            this.showLoader = true;

            this.calcularTarifa()!.pipe(
                debounceTime(200),
                distinctUntilChanged(),
                catchError(error => {
                    this.tramiteService.textTarifa='Calculo de tarifa no disponible en este momento.';
                    this.showLoader = false;
                    this.handleTarifaError(error);
                    return throwError(() => error);
                })
            ).subscribe({
                next: (result) => {
                    this.showLoader = false;
                    if (result && result.body) {
                        let respuesta: TarifarioInterface[] | null = result.body;
                        for (let i of respuesta!) {
                            if (i.total) {
                                this.tramiteService.textTarifa='';
                                this.tarifa = parseFloat(i.total.toFixed(2))!;
                            } else {
                                this.tarifa = 0;
                            }
                        }
                    }
                },
                error: (error) => {
                    this.showLoader = false;
                },
                complete: () => {
                    this.showLoader = false;
                }
            });
        }
    }

    private handleTarifaError(error: any) {
        let text = error.mensaje;
        if (error.error && error.error.mensaje) {
            text = error.error.mensaje;
        } else if (error.message) {
            text = error.message;
        }
        if (text.includes('api')) {
            text = 'Ocurrió un error al procesar, intente mas tarde';
        }

        Swal.fire({
            icon: "error",
            title: "Error",
            text: text ? text : "Ocurrió un error al procesar, intente mas tarde",
            showDenyButton: true,
            showConfirmButton: false,
            denyButtonText: `Ok`
        });
    }

    private showErrorMessage(message: string) {
        Swal.fire({
            icon: "error",
            title: "Error",
            text: message,
            showDenyButton: true,
            showConfirmButton: false,
            denyButtonText: `Ok`
        });
    }

    areaTotalEffect = effect(() => {
        if (this.tramiteService.areaTotalSignal() !== 0 && this.tramiteService.areaTotalSignal() !== null ||
            (this.proyectoAsignado.length > 0 && this.proyectoAsignado[0]?.idEntorno !== undefined &&
                this.tramiteService.tiposAreas().length > 0)) {
            setTimeout(() => {
                this.onChangeCalcularTarifa();
            }, 200);
        }
    }, {allowSignalWrites: true});

    @HostListener('window:beforeunload', ['$event'])
    unloadHandler(event: Event): void {
        this.tramiteService.limpiarDatosRequisitos();
    }
}
